// Global auth token holder for all fetch requests
import { getAuthTokenCookie, setAuthTokenCookie } from './authTokenCookie';

let _authToken = getAuthTokenCookie();
export let authToken = _authToken;

export function setAuthToken(token) {
	_authToken = token;
	authToken = token;
	setAuthTokenCookie(token);
}

export function loadAuthTokenFromCookie() {
	const token = getAuthTokenCookie();
	_authToken = token;
	authToken = token;
}
